import { TextProps } from '@bonanza-social/moonlight/lib/common/Text/Text.types';
import { IconProps, NamespacedImageKeys } from '@bonanza-social/moonlight';
import { RewardType } from '../../state/rewards.types';

export const REWARD_IMAGES: Record<
  Exclude<RewardType, RewardType.FreeSpins | RewardType.Tokens>,
  NamespacedImageKeys
> = {
  [RewardType.Coins]: 'common.BonanzaCoinStack',
  [RewardType.Cash]: 'common.BonanzaPiggy',
  [RewardType.Bonus]: 'common.BonanzaPiggy',
  [RewardType.DailyGift]: 'common.BonanzaCoinStack',
  [RewardType.DailyWheel]: 'common.BonanzaCoinStack',
  [RewardType.InstantWheel]: 'common.BonanzaWheel',
  [RewardType.Wheel]: 'common.BonanzaWheel',
  [RewardType.Scratcher]: 'common.BonanzaScratchcard',
};

export const REWARD_TEXTS: Partial<Record<RewardType, TextProps['locKey']>> = {
  [RewardType.Coins]: 'bonanzaCoins',
  [RewardType.Cash]: 'cash',
  [RewardType.Bonus]: 'bonus',
  [RewardType.FreeSpins]: 'freeSpins',
  [RewardType.DailyGift]: 'dailyGift',
  [RewardType.DailyWheel]: 'dailyWheel',
  [RewardType.InstantWheel]: 'wheelSpins',
  [RewardType.Wheel]: 'wheelSpins',
  [RewardType.Scratcher]: 'scratchcards',
};

export const REWARD_BUTTON_TEXTS: Record<RewardType, TextProps['locKey']> = {
  [RewardType.Coins]: 'goToBonanzaShop',
  [RewardType.Cash]: 'ok',
  [RewardType.Bonus]: 'ok',
  [RewardType.FreeSpins]: 'playNow',
  [RewardType.DailyGift]: 'close',
  [RewardType.DailyWheel]: 'close',
  [RewardType.InstantWheel]: 'spinNow',
  [RewardType.Tokens]: 'ok',
  [RewardType.Wheel]: 'spinNow',
  [RewardType.Scratcher]: 'scratchNow',
};

export const REWARD_ICONS: Record<
  Exclude<RewardType, RewardType.Tokens>,
  IconProps['name']
> = {
  [RewardType.Coins]: 'bonanzaCoin',
  [RewardType.Cash]: 'bonanzaDollar',
  [RewardType.Bonus]: 'bonanzaDollar',
  [RewardType.FreeSpins]: 'slotsDark',
  [RewardType.DailyGift]: 'bonanzaCoin',
  [RewardType.DailyWheel]: 'bonanzaCoin',
  [RewardType.InstantWheel]: 'spinWheel',
  [RewardType.Wheel]: 'metaWheel',
  [RewardType.Scratcher]: 'scratchcards',
};

export const IMAGE_COMMON_PROPS = {
  contentFit: 'contain',
  width: '100%',
  height: '100%',
  pointerEvents: 'none',
} as const;

export const DEFAULT_ANIMATION_DELAY = 1000;
export const DEFAULT_ANIMATION_DURATION = 1000;
export const TEXT_ANIMATION_DURATION = 250;
